export default __webpack_public_path__ + "locales/fi/FormGallery.json?hash=acd0aa977fe961cc6ca6e3dbc189e04c";